"use client";

import Navbar from "@/components/navbar/Navbar";
import { cn } from "@/lib/utils";

export interface CreateWorkspaceAppBarProps {
  showNewDress?: boolean;
  newDressDisabled?: boolean;
  showPageHeading?: boolean;
  onNewDress: () => void;
  onDesignHelp?: () => void;
  className?: string;
}

/** The site navigation stays shared; the workspace owns its reset confirmation. */
export default function CreateWorkspaceAppBar({
  showNewDress = false,
  newDressDisabled = false,
  showPageHeading = true,
  onNewDress,
  onDesignHelp,
  className,
}: CreateWorkspaceAppBarProps) {
  return (
    <div
      data-slot="create-workspace-app-bar"
      className={cn("sticky top-0 z-40 shrink-0", className)}
    >
      {showPageHeading ? <h1 className="sr-only">Design your dress</h1> : null}
      <Navbar
        onNewDress={showNewDress ? onNewDress : undefined}
        newDressDisabled={newDressDisabled}
        onDesignHelp={onDesignHelp}
      />
    </div>
  );
}
